import { select, addClass, removeClass } from 'helpers/dom'

const selectors = {
  SHOW_PASSWORD_SELECTOR: '.js-show-password',
  IS_SHOW_PASSWORD_CLASS: 'is-show-password',
  INPUT_TAG: 'input'
}

class CustomInputPassword extends HTMLElement {
  constructor() {
    super()

    this.buttonShow = select(selectors.SHOW_PASSWORD_SELECTOR, this)
    this.input = select(selectors.INPUT_TAG, this)
    this.attackEvent()
  }

  attackEvent() {
    if (this.buttonShow) {
      this.buttonShow.addEventListener('click', () => {
        if (this.input.type === 'password') {
          this.input.type = 'text'
          addClass(selectors.IS_SHOW_PASSWORD_CLASS, this.buttonShow)
        } else {
          this.input.type = 'password'
          removeClass(selectors.IS_SHOW_PASSWORD_CLASS, this.buttonShow)
        }
      })
    }
  }
}

customElements.define('custom-input-password', CustomInputPassword)
